<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="试卷名称" prop="groupName">
            <el-input class="form-input" v-model="searchForm.groupName" clearable></el-input>
          </el-form-item>
          <el-form-item label="试卷类型" prop="type">
            <el-select v-model="searchForm.type" clearable @change="onSearch">
              <el-option v-for="item in questionTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
            <el-input class="form-input" v-model="searchForm.createdBy" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编辑时间" prop="updatedTime">
            <q-date-picker v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="newAddQuestion">新增试卷</el-button>
        <el-button type="primary" size="small" @click="importQuestion">导入试卷</el-button>
        <el-button type="primary" size="small"  @click="download">模版下载 </el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        border
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="groupName" label="试卷名称"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column  label="试卷类型" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.type | questionType}}
          </template>
        </el-table-column>
        <el-table-column prop="questionsCount" label="题目数" align="center"  width="120"></el-table-column>
        <el-table-column prop="createdBy" label="创建人"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="updatedTime" label="编辑时间" >
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="rollingStatus" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.status | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="180" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button v-if="scope.row.status == 'onLine'" type="text" size="small" @click="handleState(scope.row,'offLine')">下线</el-button>
            <el-button v-else type="text" size="small" @click="handleState(scope.row, 'onLine')">上线</el-button>
            <el-button v-if="scope.row.status == 'offLine'" type="text" size="small" @click="handleAdd(scope.row,'edit')">编辑</el-button>
            <el-button type="text" size="small" @click="handleAdd(scope.row,'see')">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <import-dialog v-if="isShowImport" :visible.sync="isShowImport" ></import-dialog>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin'
import pagePathMixin from '@/utils/page-path-mixin'
import importDialog from '@/views/import-export/import-dialog'
import { downloadFile } from '@/utils/downloadFile.js'
export default {
  name: 'ImageCarouselList',
  mixins: [tableMixin,pagePathMixin],
  components: {
    importDialog
  },
  data () {
    return {
      isShowImport: false,
      searchForm: {
        groupName: '',
        type: '',
        createdBy: '',
        status: '',
        createUser: '',
        startTime: '',
        endTime: '',
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      questionTypeList: [
        { value: '', label: '全部' },
        { value: 'radio', label: '单选' },
        { value: 'checkBox', label: '多选' },
        { value: 'checking', label: '判断' }
      ],
      statusOptions: [
        { value: '', label: '全部' },
        { value: 'onLine', label: '使用中' },
        { value: 'offLine', label: '下线' }
      ]
    }
  },
  methods: {
    init () {
      this.onSearch()
    },
    getList () {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.question.selectQuestionPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || []
          this.total = total
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCurrentChange (row) {
      this.selection = row
    },
    onSizeChange (pageSize) {
      this.pageSize = pageSize
      // 切换每页条数后从第一页查询
      this.pageNum = 1
      this.getList()
    },
    onNumChange (pageNum) {
      this.pageNum = pageNum
      this.getList()
    },
    handleSelectionChange (selection) {
      this.selection = selection
    },
    resetSearchForm () {
      this.$refs.searchForm.resetFields()
      this.initDate()
      this.filterParam = {}
      this.onSearch()
    },
    onSearch () {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {}
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val
        }
      }
      this.pageNum = 1
      this.getList()
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    newAddQuestion() {
      this.openSubPage({
        path: '/content/newaddOrEdit',
      })
    },
    handleAdd (row, type) {
      this.openSubPage({
        path: '/content/newaddOrEdit',
        query: { id: row.questionGroupId, from: type }
      })
    },
    handleState (row, state) {
      this.$api.question
        .updateQuestionGroupStatus({ id: row.questionGroupId, state })
        .then(({ data }) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功'
          })
          this.getList()
        })
    },
    handleDelete (row) {
      this.$confirm('删除后数据不可恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.carouselImage
            .updateState(row.rollingId, 2)
            .then(({ data }) => {
              this.$notify.success({
                title: '成功',
                message: '删除成功'
              })
              this.getList()
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    importQuestion() {
      this.isShowImport = true
    },
    download () {
      this.$api.common.downloadTemplate('importQuestion').then(res => {
        if (res.success) {
          downloadFile(res.data.templatePath,'题库模版')
        }
      })
    },
  },
  filters: {
    statusEnum (val) {
      return val === 'onLine' ? '使用中' : '下线'
    },
    questionType (val) {
      const map = {
        radio: '单选',
        checkBox: '多选',
        checking: '判断'
      }
      return map[val]
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
.date-input {
  width 130px !important
}
.to {
  display: inline-block;
  margin: 0 4px;
}
</style>
